var $8c59fd0c2c96821b$exports = {};
$8c59fd0c2c96821b$exports = {
    "Clear search": `Vymazat hled\xe1n\xed`
};


export {$8c59fd0c2c96821b$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
